/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      // gsap.registerPlugin( ScrollTrigger );

      let navHeight = $( '.navbar' ).outerHeight();

      if ( $( '#wpadminbar' ).length ) {
        navHeight += $( '#wpadminbar' ).outerHeight();
      }

      $( '.progress-bar' ).css( 'top', navHeight );

      // Go to prev page
      $( '.quoter-nav .quoter-back' ).click( function() {
        $( '.current-page .gform_previous_button' ).trigger( 'click' );
      } );

      $( document ).on( 'gform_page_loaded', function( event, formID, currentPage ) {
        $( '.quoter .pagination-area li' ).removeClass( 'is-active' );
        $( '.quoter .pagination-area li:nth-child(' + currentPage + ')' ).addClass( 'is-active' );
        $( '.quoter .fit-image' ).addClass( 'is-hidden' );
        $( '.quoter .fit-image:nth-child(' + currentPage + ')' ).removeClass( 'is-hidden' );
        $( '.quoter-form' ).find( '.gsection.hide-text .gsection_title' ).attr( 'aria-hidden', true );
        $( '.quoter-form' ).find( '.gsection.hide-text .gsection_description' ).attr( 'aria-hidden', true );
      } );

      // Set Current Page
      $( '.quoter-form .gform_page:first-child' ).addClass( 'current-page' ).attr( 'tabindex', -1 );

      $( '.is-start-btn' ).on( 'toggleAfter', function( ) {
        setTimeout( function() {
          $( '.quoter-form .gform_page.current-page' ).trigger( 'focus' );
        }, 0 );
      } );

      $( '.quoter-form' ).find( '.gsection.hide-text .gsection_title' ).attr( 'aria-hidden', true );
      $( '.quoter-form' ).find( '.gsection.hide-text .gsection_description' ).attr( 'aria-hidden', true );

      function moveProgressArea() {
        $( '.quoter .gform_body .gform_page' ).each( function() {
          let progress = $( '.quoter-form > .gf_progressbar_wrapper' ).html();
          progress = progress.replace( 'Step ', 'Part ' );
          console.log( progress );
          $( '.quoter-form > .gf_progressbar_wrapper' ).hide();
          $( this ).find( '.gform_fields > .gsection:first-child' ).prepend( '<div class="custom-progress-wrapper">' + progress + '</div>' );
        } );
      }

      function movePagination() {
        const pagination = $( '.pagination-area' ).prop( 'outerHTML' );
        $( '.quoter .gform_body .gform_page' ).each( function() {
          $( this ).find( '.gform_fields > .gsection:first-child' ).prepend( pagination );
          $( this ).find( '.gform_fields > .gsection:first-child .pagination-area' ).removeClass( 'flex lg:hidden' ).addClass( 'hidden lg:block per-page' );
        } );
      }

      // Go to next page on radio click ---auto submit is violates WCAG 3.2.2
      /*       $( document ).on( 'click', '.radio-page input[type="radio"]', function() {
        $( '.current-page .gform_next_button' ).trigger( 'click' );
      } ); */

      // Set progress
      const totalPages = $( '.quoter .gform_body .gform_page' ).length;
      const progress = 1 / totalPages;
      $( '.quoter .progress-bar .progress' ).css( {
        '-webkit-transform': 'scaleX(' + progress + ')',
        'transform': 'scaleX(' + progress + ')',
      } );

      moveProgressArea();
      movePagination();

      // Page change stuff
      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        const progress = currentPage / totalPages;
        $( '.quoter .progress-bar .progress' ).css( {
          '-webkit-transform': 'scaleX(' + progress + ')',
          'transform': 'scaleX(' + progress + ')',
        } );

        moveProgressArea();
        movePagination();

        // Update quoter nav
        if ( currentPage > 1 ) {
          $( '.quoter-nav' ).removeClass( 'hidden' );
        } else {
          $( '.quoter-nav' ).addClass( 'hidden' );
        }

        // Set current page, scroll to top
        $( '.quoter-form .gform_page' ).removeClass( 'current-page' );
        $( '#gform_page_' + formId +'_' + currentPage ).addClass( 'current-page' ).attr( 'tabindex', '0' );
        enableDisableNext();
        $( '.current-page' ).focus();
        $( 'html, body' ).animate( {scrollTop: 0}, 'slow' );
      } );

      // Hide quoter nav on submit
      $( document ).on( 'gform_confirmation_loaded', function( event, formId ) {
        $( '.quoter-nav' ).hide();
        $( '.gform_confirmation_message' ).attr( 'tabindex', '0' ).focus();
      } );

      function enableDisableNext() {
        let req = false;
        $( '.current-page .gfield' ).each( function() {
          if ( $( this ).hasClass( 'gfield_contains_required' ) ) {
            req = true;
          }
        } );

        if ( req ) {
          $( '.current-page .gform_next_button' ).attr( 'disabled', 'true' );
        }
      }

      enableDisableNext();

      $( document ).on( 'change keydown', '.current-page:not(.radio-page) .gfield.gfield_contains_required input, .current-page:not(.radio-page) .gfield.gfield_contains_required textarea', function() {
        let valLength = $( this ).val().length;
        if ( $( this ).parent().find( 'input[type="radio"], input[type="checkbox"]' ).length ) {
          valLength = $( this ).parent().find( 'input:checked' ).length;
        }

        if ( valLength > 0 ) {
          $( '.current-page .gform_next_button' ).removeAttr( 'disabled' );
        } else {
          $( '.current-page .gform_next_button' ).attr( 'disabled', 'true' );
        }
      } );
    },
    finalize: function() {
    },
  };
  app.registerComponent( 'quoter', COMPONENT );
} )( app );
